<template>
    <div>
        <modal-box v-model="isEmptyFiltersModalActive" :title="__('Choice')" :button-label="__('Ok')"
                   @confirm="isEmptyFiltersModalActive = false">
            {{ __('You have not selected any filters') }}
        </modal-box>

        <modal-box v-model="isSelectNomenclatureModalActive" :title="__('Choice')" has-cancel @confirm="openNextModal">
            <field class="-mb-0">
                <check-radio-picker
                    column
                    name="selectedNomenclatureType"
                    type="radio"
                    v-model="selectedNomenclatureType"
                    :options="{ catalog: __('Subject'), brand: __('Manufacturer\'s brand'), destinationBrand: __('Destination brand') }"
                ></check-radio-picker>
            </field>
            <slot/>
        </modal-box>

        <modal-box v-model="isCatalogModalActive" size="large" :title="__('Filter by catalog')" has-cancel
                   @confirm="selectCatalog"
                   @cancel="cancelCatalog">
            <field :label="__('Subject')">
                <control :options="catalog_options" v-model="catalog"
                         :required="true"
                         :placeholder="catalog_options.length ? __('Select') : __('List is empty')"/>
            </field>
            <field :label="__('Category')">
                <VueMultiselect
                    v-model="category"
                    :options="category_options"
                    :taggable="false"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="false"
                    :placeholder="category_options.length ? __('Select') : __('List is empty')"
                    :selectLabel="__('Press enter to select')"
                    :selectedLabel="__('Selected')"
                    :deselectLabel="__('Press enter to remove')"
                    label="label"
                    track-by="label"
                    :preselect-first="false">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span class="multiselect__single" v-if="values.length && !isOpen">
                        {{ values.length }} options selected</span>
                    </template>
                </VueMultiselect>
            </field>
            <field :label="__('Sub category')" v-if="sub_category_options.length > 0">
                <VueMultiselect
                    v-model="sub_category"
                    :options="sub_category_options"
                    :taggable="false"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="false"
                    :placeholder="sub_category_options.length ? __('Select') : __('List is empty')"
                    :selectLabel="__('Press enter to select')"
                    :selectedLabel="__('Selected')"
                    :deselectLabel="__('Press enter to remove')"
                    label="label"
                    track-by="label"
                    :preselect-first="false">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                        {{ values.length }} options selected</span>
                    </template>
                </VueMultiselect>
            </field>
            <field :label="__('Sub category')" v-if="sub_sub_category_options.length > 0">
                <VueMultiselect
                    v-model="sub_sub_category"
                    :options="sub_sub_category_options"
                    :taggable="false"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="false"
                    :placeholder="sub_sub_category_options.length ? __('Select') : __('List is empty')"
                    :selectLabel="__('Press enter to select')"
                    :selectedLabel="__('Selected')"
                    :deselectLabel="__('Press enter to remove')"
                    label="label"
                    track-by="label"
                    :preselect-first="false">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                        {{ values.length }} options selected</span>
                    </template>
                </VueMultiselect>
            </field>
        </modal-box>

        <modal-box v-model="isBrandModalActive" :title="__('Choice of manufacturer\'s brand')" has-cancel
                   @confirm="selectBrands">
            <field :label="__('Manufacturer\'s brand')">
                <VueMultiselect
                    v-model="brand"
                    :options="brand_options"
                    :taggable="false"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="false"
                    :placeholder="__('Select')"
                    :selectLabel="__('Press enter to select')"
                    :selectedLabel="__('Selected')"
                    :deselectLabel="__('Press enter to remove')"
                    label="label"
                    track-by="label"
                    :preselect-first="false">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                        {{ values.length }} options selected</span>
                    </template>
                </VueMultiselect>
            </field>
        </modal-box>

        <modal-box v-model="isDestinationBrandModalActive" :title="__('Choice of a destination brand')" has-cancel
                   @confirm="selectDestinationBrands">
            <field :label="__('Destination brand')">
                <VueMultiselect
                    v-model="destinationBrand"
                    :options="destinationBrand_options"
                    :taggable="false"
                    :multiple="true"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="false"
                    :placeholder="__('Select')"
                    :selectLabel="__('Press enter to select')"
                    :selectedLabel="__('Selected')"
                    :deselectLabel="__('Press enter to remove')"
                    label="label"
                    track-by="label"
                    :preselect-first="false">
                    <template slot="selection" slot-scope="{ values, search, isOpen }">
                        <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                        {{ values.length }} options selected</span>
                    </template>
                </VueMultiselect>
            </field>
        </modal-box>

        <div class="relative">
            <jb-buttons class="absolute -top-2 right-0 justify-end">
                <jb-button type="button" small color="info" :icon="mdiPlusBox"
                           @click.prevent="isSelectNomenclatureModalActive = true"/>
                <jb-button type="button" small color="danger" :icon="mdiCloseBoxMultiple"
                           @click.prevent="removeAllNomenclature()"/>
            </jb-buttons>
            <field :label="__('Choice of nomenclature')">
                <multi-select v-model="computedValue"
                              @clickOnEmptyText="isSelectNomenclatureModalActive = true"
                              @clickOnEmptyField="isSelectNomenclatureModalActive = true"/>
            </field>
        </div>
    </div>
</template>

<script>

import {computed} from 'vue'
import VueMultiselect from 'vue-multiselect'
import Field from '@/Components/Dashboard/Field'
import Control from '@/Components/Dashboard/Control'
import CheckRadioPicker from '@/Components/Dashboard/CheckRadioPicker'
import JbButton from '@/Components/Dashboard/JbButton'
import JbButtons from '@/Components/Dashboard/JbButtons'
import MultiSelect from '@/Components/Dashboard/MultiSelect'
import ModalBox from "@/Components/Dashboard/ModalBox";
import {ref} from "vue";
import {
    mdiPlusBox,
    mdiCloseBoxMultiple
} from "@mdi/js";

export default {
    name: "CatalogSelector",
    components: {
        VueMultiselect,
        Field,
        Control,
        CheckRadioPicker,
        JbButton,
        JbButtons,
        MultiSelect,
        ModalBox
    },
    props: {
        site: Object,
        modelValue: {
            type: Array,
            default: []
        }
    },
    emits: ['update:modelValue'],
    watch: {
        catalog(newVal, oldVal) {
            const self = this;
            self.category = [];
            self.category_options = [];

            if (typeof newVal.id === "undefined")
                return

            this.getCategoriesByCatalog().then(response => {
                response.data.sort((a, b) => a.Order - b.Order)

                for (const itemId in response.data) {
                    const item = response.data[itemId]
                    const label = item.__translation.Name_plu[6] ?? item.Name
                    self.category_options.push({id: item.Id, label: label});
                }
            });
        },
        category(newVal, oldVal) {
            if (newVal.length === 0) {
                this.clearSubCategoryOptions()
                return
            }

            if (newVal.length > oldVal.length) {
                this.addNewSubCategoryOptions(newVal, oldVal)
            } else {
                this.removeSubCategoryOptions(newVal, oldVal)
            }
        },
        sub_category(newVal, oldVal) {
            if (newVal.length === 0) {
                this.clearSubSubCategoryOptions()
                return
            }

            if (newVal.length > oldVal.length) {
                this.addNewSubSubCategoryOptions(newVal, oldVal)
            } else {
                this.removeSubSubCategoryOptions(newVal, oldVal)
            }
        }
    },
    data() {
        return {
            rememberSiteId: null,
            selectedNomenclatureType: 'catalog',
            brand: [],
            destinationBrand: [],
            brand_options: [],
            destinationBrand_options: [],
            catalog: {},
            catalog_options: [],
            category: [],
            sub_category: [],
            category_options: [],
            sub_category_options: [],
            sub_sub_category: [],
            sub_sub_category_options: []
        }
    },
    setup(props, {emit}) {
        const computedValue = computed({
            get: () => props.modelValue,
            set: value => {
                emit('update:modelValue', value)
            }
        })

        const isSelectNomenclatureModalActive = ref(false)
        const isEmptyFiltersModalActive = ref(false)
        const isCatalogModalActive = ref(false)
        const isBrandModalActive = ref(false)
        const isDestinationBrandModalActive = ref(false)

        return {
            mdiPlusBox,
            mdiCloseBoxMultiple,
            computedValue,
            isSelectNomenclatureModalActive,
            isEmptyFiltersModalActive,
            isCatalogModalActive,
            isBrandModalActive,
            isDestinationBrandModalActive
        }
    },
    methods: {
        addNewSubSubCategoryOptions(newVal, oldVal) {
            const self = this

            const subCategoriesWithChildren = newVal.filter(item => item['has-children'] === true)
            if (subCategoriesWithChildren.length === 0) {
                return
            }

            this.getCategories(subCategoriesWithChildren.map(item => item.id)).then(response => {
                response.data.sort((a, b) => a.Order - b.Order)

                for (const itemId in response.data) {
                    const item = response.data[itemId]
                    const label = item.__translation.Name_plu[6] ?? item.Name
                    const option = {
                        id: item.Id,
                        label: label,
                        name: label,
                        'parent-id': item.ParentId,
                    }

                    const parentItem = newVal.find(parentItem => parentItem.id === item.ParentId)
                    if (typeof parentItem !== "undefined") {
                        option.parentLabel = `${parentItem.parentLabel}, ${parentItem.label}`
                    }

                    if (!self.sub_sub_category_options.find(el => el.id === option.id)) {
                        self.sub_sub_category_options.push(option)
                    }
                }
            });
        },
        removeSubSubCategoryOptions(newVal, oldVal) {
            oldVal.forEach(element => {
                if (!newVal.find(item => item.id === element.id)) {
                    this.sub_sub_category_options = this.sub_sub_category_options.filter(item => item['parent-id'] !== element.id)
                    this.sub_sub_category = this.sub_sub_category.filter(item => item['parent-id'] !== element.id)
                }
            })
        },
        addNewSubCategoryOptions(newVal, oldVal) {
            const self = this

            let categories = []
            newVal.forEach(element => {
                if (!oldVal.find(item => item.id === element.id)) {
                    categories.push(element)
                }
            })

            if (categories.length > 0) {
                this.getCategories(categories.map(item => item.id)).then(response => {
                    response.data.sort((a, b) => a.Order - b.Order)

                    for (const itemId in response.data) {
                        const item = response.data[itemId]
                        const label = item.__translation.Name_plu[6] ?? item.Name
                        const option = {
                            id: item.Id,
                            label: label,
                            name: label,
                            'parent-id': item.ParentId,
                            'has-children': item.HasChildren
                        }

                        const parentItem = newVal.find(parentItem => parentItem.id === item.ParentId)
                        if (typeof parentItem !== "undefined") {
                            option.parentLabel = parentItem.label
                            option.label += ` (${parentItem.label})`
                        }

                        self.sub_category_options.push(option)
                    }
                });
            }
        },
        removeSubCategoryOptions(newVal, oldVal) {
            oldVal.forEach(element => {
                if (!newVal.find(item => item.id === element.id)) {
                    this.sub_category_options = this.sub_category_options.filter(item => item['parent-id'] !== element.id)
                    this.sub_category = this.sub_category.filter(item => item['parent-id'] !== element.id)
                }
            })
        },
        clearSubCategoryOptions() {
            this.sub_category = []
            this.sub_category_options = []
            this.clearSubSubCategoryOptions()
        },
        clearSubSubCategoryOptions() {
            this.sub_sub_category = []
            this.sub_sub_category_options = []
        },
        getDestinationBrandOptions() {
            this.destinationBrand = []

            if (this.rememberSiteId !== this.site.id) {
                this.destinationBrand_options = []
            }
            this.rememberSiteId = this.site.id;

            if (this.destinationBrand_options.length > 0) {
                this.isDestinationBrandModalActive = true
                return
            }

            const self = this
            this.getDestinationBrands().then(response => {
                for (const itemId in response.data) {
                    const item = response.data[itemId]
                    self.destinationBrand_options.push({id: item.id, label: item.name})
                }
                self.isDestinationBrandModalActive = true
            });
        },
        getBrandOptions() {
            this.brand = []

            if (this.rememberSiteId !== this.site.id) {
                this.brand_options = []
            }
            this.rememberSiteId = this.site.id;

            if (this.brand_options.length > 0) {
                this.isBrandModalActive = true
                return
            }

            const self = this
            this.getBrands().then(response => {
                for (const itemId in response.data) {
                    const item = response.data[itemId]
                    self.brand_options.push({id: item.id, label: item.name})
                }
                self.isBrandModalActive = true
            });
        },
        getCatalogOptions() {
            this.catalog = {}

            if (this.rememberSiteId !== this.site.id) {
                this.catalog_options = []
            }

            this.rememberSiteId = this.site.id;

            if (this.catalog_options.length > 0) {
                this.isCatalogModalActive = true
                return
            }

            const self = this
            this.getCatalog().then(response => {
                for (const itemId in response.data) {
                    const item = response.data[itemId]
                    const label = item.Id.charAt(0).toUpperCase() + item.Id.slice(1)
                    self.catalog_options.push({id: item.Id, label: label})
                }
                self.isCatalogModalActive = true
            });
        },
        getCatalog() {
            return this.apiRequest('api.v2.catalog.get', {
                'siteId': this.site.api_source_id
            })
        },
        getCategoriesByCatalog() {
            return this.apiRequest('api.v2.categories.by-catalog', {
                'catalogId': this.catalog.id,
                'siteId': this.site.api_source_id
            })
        },
        getCategories(parentIds = []) {
            return this.apiRequest('api.v2.categories.index', {
                'catalogId': this.catalog.id,
                'parentIds': parentIds,
                'siteId': this.site.api_source_id
            })
        },
        getBrands(callback = null) {
            return this.apiRequest('api.v1.brands.index', {'siteId': this.site.api_source_id})
        },
        getDestinationBrands(callback = null) {
            return this.apiRequest('api.v1.destination-brands.index', {'siteId': this.site.api_source_id})
        },
        removeAllNomenclature() {
            this.computedValue = [];
        },
        openNextModal() {
            if (this.selectedNomenclatureType === 'catalog') {
                this.getCatalogOptions()
            } else if (this.selectedNomenclatureType === 'brand') {
                this.getBrandOptions()
            } else {
                this.getDestinationBrandOptions()
            }
        },
        pushToNomenclature(element, addCatalogLabel = true, type = 'catalog') {
            const search = this.computedValue.find(el => el.type === type && el.id == element.id);
            if (typeof search !== "undefined") {
                return
            }

            if (typeof element.id === "undefined") {
                this.isEmptyFiltersModalActive = true
                return
            }

            let name = element.label
            if (typeof element.name !== "undefined") {
                name = element.name
            }
            if (typeof element.parentLabel !== "undefined") {
                name = `${element.parentLabel}, ${name}`
            }
            if (addCatalogLabel) {
                name = `${this.catalog.label}, ${name}`
            }

            this.computedValue.push({
                type: type,
                id: element.id,
                name: name,
                catalog_id: this.catalog.id
            });
        },
        cancelCatalog() {
            this.category = []
            this.sub_category = []
            this.sub_sub_category = []
        },
        selectCatalog() {
            const self = this;

            if (this.sub_category.length > 0 || this.category.length > 0) {
                const categories = [];

                this.sub_sub_category.forEach(item => {
                    categories.push(item['parent-id']);
                    self.pushToNomenclature(item, true, 'category')
                })

                this.sub_category.forEach(item => {
                    categories.push(item['parent-id']);
                    if (categories.includes(item.id) === false) {
                        self.pushToNomenclature(item, true, 'category')
                    }
                })

                this.category.forEach(item => {
                    if (categories.includes(item.id) === false) {
                        self.pushToNomenclature(item, true, 'category')
                    }
                })

            } else {
                self.pushToNomenclature(self.catalog, false)
            }

            this.cancelCatalog()
        },
        selectBrands() {
            const self = this;
            this.brand.forEach(element => {
                self.pushToNomenclature(element, false, 'brand')
            });
            this.brand = []
        },
        selectDestinationBrands() {
            const self = this;
            this.destinationBrand.forEach(element => {
                self.pushToNomenclature(element, false, 'destinationBrand')
            });
            this.destinationBrand = []
        },
        showLoading() {
            document.body.classList.add('_show_loading');
        },
        hideLoading() {
            document.body.classList.remove('_show_loading');
        },
        apiRequest(route, data) {
            const self = this
            return new Promise((resolve, reject) => {
                self.showLoading()
                axios.post(this.route(route), data).then(response => {
                    self.hideLoading()
                    resolve(response)
                }).catch(error => {
                    self.hideLoading()
                    console.error(error)
                    reject(error)
                });
            });
        },
    }
}
</script>

<style scoped>

</style>
